import React from 'react';
import './FAQs.scss';
import { getModuleBackgroundColor } from '../../util/getModuleBackgroundColor';

/**
 * renders faqs module
 * @param {string} title
 * @param {array} faqs
 * @param {string} backgroundColor
 * @returns {JSX.Element}
 * @constructor
 */
const FAQs = ({ title, faqs, backgroundColor }) => {
  const DARK_TYPES = ['white', 'orange', 'gray', 'dark-gray'];

  // We need to override the details marker elements with inline svg
  const plusIcon = DARK_TYPES.includes(backgroundColor)
    ? `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23141414'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M9 1.5c.207 0 .375.168.375.375v6.749l6.75.001c.207 0 .375.168.375.375s-.168.375-.375.375l-6.75-.001v6.751c0 .207-.168.375-.375.375s-.375-.168-.375-.375V9.374l-6.75.001c-.207 0-.375-.168-.375-.375s.168-.375.375-.375l6.75-.001V1.875c0-.207.168-.375.375-.375z' transform='translate(-1167 -3088) translate(0 2792) translate(228 248) translate(939 48)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"`
    : `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f5f5f5'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M9 1.5c.207 0 .375.168.375.375v6.749l6.75.001c.207 0 .375.168.375.375s-.168.375-.375.375l-6.75-.001v6.751c0 .207-.168.375-.375.375s-.375-.168-.375-.375V9.374l-6.75.001c-.207 0-.375-.168-.375-.375s.168-.375.375-.375l6.75-.001V1.875c0-.207.168-.375.375-.375z' transform='translate(-1167 -3088) translate(0 2792) translate(228 248) translate(939 48)'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"`;

  const minusIcon = DARK_TYPES.includes(backgroundColor)
    ? `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23141414'%3E%3Cg%3E%3Cg%3E%3Cg transform='translate(-1224 -6252) translate(224 5758) translate(64 449) translate(936 45)'%3E%3Crect width='1' height='20' x='11.5' y='2' rx='.5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"`
    : `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23F5f5f5'%3E%3Cg%3E%3Cg%3E%3Cg transform='translate(-1224 -6252) translate(224 5758) translate(64 449) translate(936 45)'%3E%3Crect width='1' height='20' x='11.5' y='2' rx='.5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"`;

  return (
    <div className={`c-faqs ${getModuleBackgroundColor(backgroundColor)}`}>
      <div className="c-faqs__inner">
        {title !== '' && (
          <div className="c-faqs__title h2-roobert">
            <h2>{title}</h2>
          </div>
        )}
        <div className={`c-faqs__faqs ${DARK_TYPES.includes(backgroundColor) ? '' : 'is-dark'}`}>
          {faqs.map((faq, i) => (
            <details
              key={i}
              className={`c-faqs__faq ${DARK_TYPES.includes(backgroundColor) ? '' : 'is-dark'}`}
            >
              <summary className="c-faqs__faq-question h4-roobert">{faq.question}</summary>
              <p className="c-faqs__faq-answer body-2">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
      <style>{`
                .c-faqs__faq[open] .c-faqs__faq-question {
                    list-style-image: url(${minusIcon});
                }
                
                .c-faqs__faq[open] .c-faqs__faq-question::-webkit-details-marker {
                    background: url(${minusIcon});
                    color: transparent;
                    position: absolute;
                    transform: rotate(90deg);
                    margin-top: -.5rem;
                }
                
                .c-faqs__faq-question {
                    list-style-image: url(${plusIcon});
                }
                
                .c-faqs__faq-question::-webkit-details-marker {
                    background: url(${plusIcon});
                    color: transparent;
                    position: absolute;
                }    
            `}</style>
    </div>
  );
};

export default FAQs;
